// extracted by mini-css-extract-plugin
export default {"root":"PreviewIcon_root__xSriM"};